module.exports = __webpack_public_path__ + "static/media/image.3956556f.svg";